module.exports = __webpack_public_path__ + "static/media/SCBworld.1bec3c76.svg";